import { fontSize, fontWeight, theme } from "@tm/utility/global";
import styled from "styled-components";

export const TripOptionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
`;

export const RadioItem = styled.div<{ $isSelected: boolean }>`
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: 4px 8px;
  border-radius: 16px;
  cursor: pointer;
  font-size: ${fontSize.font14};
  white-space: nowrap;
  background: ${({ $isSelected }) =>
    $isSelected ? theme.lightBlueBg : theme.whiteText};
  font-weight: ${({ $isSelected }) =>
    $isSelected ? fontWeight.black : fontWeight.regular};
  color: ${theme.blackText};
`;

export const RadioCircle = styled.span<{ $isSelected: boolean }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1.5px solid
    ${({ $isSelected }) => ($isSelected ? theme.blueText : theme.lightGreyText)};
  background: ${({ $isSelected }) =>
    $isSelected ? theme.blueText : theme.whiteText};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  box-sizing: border-box;
  margin-right: 2px;

  ${({ $isSelected }) =>
    $isSelected &&
    `
    &::after {
      content: "";
      display: block;
      width: 3px;
      height: 6px;
      border: solid ${theme.whiteText};
      border-width: 0 1.2px 1.2px 0;
      transform: rotate(45deg);
      margin-top: -1px;
    }
  `}
`;

export const OptionLabel = styled.span`
  display: flex;
  align-items: center;
  gap: 4px;
  line-height: 14px;
`;

export const SubtitleBadge = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 2px 2px 8px;
  border-radius: 40px;
  background: radial-gradient(
      ellipse at 0% 50%,
      rgba(233, 212, 255, 1) 0%,
      rgba(255, 255, 255, 1) 100%
    ),
    ${theme.whiteText};
  white-space: nowrap;
`;

export const SubtitleText = styled.span`
  font-size: ${fontSize.font12};
  font-weight: ${fontWeight.bold};
  line-height: 12px;
  background: ${theme.purpleGradient};
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
`;

export const InfoIconWrapper = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  width: 14px;
  height: 14px;
`;
